export default __webpack_public_path__ + "static/media/legend_help.5d31c6ec.svg";